import { DataViewer } from '@/utils/helpers/common';

import '../index.scss';

interface FileUploadDetailProps {
  description?: string;
  compact?: boolean;
}

const FileUploadDetail = ({ description, compact = false }: FileUploadDetailProps) => {
  return (
    <div className={`header-view-task-detail-project flex flex-col ${compact ? 'gap-0 mt-0' : 'gap-[12px] mt-[8px]'}`}>
      <div className={`border-collapse ${compact ? 'p-[4px]' : 'p-[16px]'}`}>
        <div
          className='w-full text-[14px] leading-[22px] whitespace-pre-wrap'
          dangerouslySetInnerHTML={{ __html: DataViewer.displayAsSanitizeHTML((description as string) || '') }}
        ></div>
      </div>
    </div>
  );
};

export default FileUploadDetail;
